import Splide from '@splidejs/splide'

function slider() {
    new Splide('.splide', {
        perPage: 2,
        perMove: 1,
        arrows: false,
        autoplay: true,
        interval: 3000,
        pauseOnHover: true,
        gap: 15,
        breakpoints: {
            640: {
                perPage: 1,
                arrows: false,
                gap:10
            }
        }

    }).mount();


    new Splide('.splide.splide-gallery', {
        type:'loop',
        perPage: 3,
        perMove: 1,
        focus:'center',
        autoHeight:true,
        autoWidth:true,
        breakpoints: {
            640: {
                perPage: 1,
                arrows: false,
                autoWidth:false,
                autoHeight:false,
                gap:10
            }
        }
    }).mount();

}

export default slider